import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import styles from './TriggerForm.module.scss';
import Input from 'component/atom/forms/input/input/Input';
import TextArea from 'component/atom/forms/text-area/TextArea';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Select from 'component/atom/forms/select/select/Select';
import Button from 'component/atom/forms/button/Button';
import Toggle from 'component/atom/forms/toggle/Toggle';

const triggerData = [{ value: 'intent', label: 'Intent' }];
const InitialForm = ({ isSystem, systemId }) => {
  const formik = useFormikContext();
  const [sections, setSections] = useState(0);
  const addSection = () => {
    formik.setFieldValue('utterances', [...formik.values.utterances, '']);
    setSections(sections + 1);
  };
  const removeSection = (index) => {
    const newKeyword = formik.values.utterances.filter((_, i) => i !== index);
    formik.setFieldValue('utterances', newKeyword);
    setSections(sections - 1);
  };

  return (
    <form className={styles['trigger-form']} onSubmit={formik.handleSubmit}>
      <div className={styles['trigger-select']}>
        <Select
          label="Triggers"
          placeholder="Select Trigger"
          options={triggerData}
          name="triggerTypeId"
          value={formik.values.triggerTypeId}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.triggerTypeId}
          touched={formik.touched.triggerTypeId}
        />
      </div>

      {formik.values.triggerTypeId == 'intent' ? (
        <>
          <Input
            label="name"
            placeholder="Enter Name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.name}
            touched={formik.touched.name}
            disabled={isSystem}
          />
          <TextArea
            label="Description"
            placeholder="Enter description (Optional)"
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.description}
            touched={formik.touched.description}
            disabled={isSystem}
          />
          {systemId === 5 ? (
            <>
              <div className={styles.border}></div>
              <Input
                label="Idle Time (Seconds)"
                placeholder="1 min"
                name="idleTime"
                value={formik.values.idleTime}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.errors.idleTime}
                touched={formik.touched.idleTime}
                inputType="number"
              />
            </>
          ) : (
            <>
              <div className={styles['label-container']}>
                <p className={styles['label']}>Keyword</p>
                <Button
                  type="plus"
                  className={styles['button']}
                  transparent
                  onClick={addSection}
                />
              </div>
              <div className={styles['questions-container']}>
                {formik.values.utterances &&
                  formik.values.utterances.map((section, index) => {
                    return (
                      <div className={styles['multi-input']} key={index}>
                        <Input
                          name={`utterances[${index}]`}
                          value={section}
                          onChange={formik.handleChange}
                          error={formik.errors?.utterances?.[index]}
                          touched={formik.touched?.utterances?.[index]}
                          placeholder="Enter a keyword"
                        />
                        <SvgWithBranding
                          type="delete_table"
                          className={styles['icon']}
                          onClick={() => removeSection(index)}
                        />
                      </div>
                    );
                  })}
              </div>
              <div className={styles.border}></div>
              <div className={styles.suggest}>
                <p>Suggestions</p>
                <Toggle
                  name="hasSuggestions"
                  value={formik.values.hasSuggestions || false}
                  onToggleChange={(e) => {
                    formik.setFieldValue(
                      `hasSuggestions`,
                      !formik.values.hasSuggestions
                    );
                  }}
                />
              </div>
            </>
          )}
          {!isSystem && <div className={styles.border}></div>}

          {formik?.values?.hasSuggestions ? (
            <>
              <div className={styles.suggest}>
                <p>AI Generated Question</p>
                <Toggle
                  name="hasAIGenerated"
                  value={formik.values.hasAIGenerated || false}
                  onToggleChange={(e) => {
                    formik.setFieldValue(
                      `hasAIGenerated`,
                      !formik.values.hasAIGenerated
                    );
                  }}
                />
              </div>
              {!formik?.values?.hasAIGenerated ? (
                <>
                  {' '}
                  <div className={styles['label-container']}>
                    <p className={styles['label']}>Predefined Suggestions</p>
                    {formik.values.suggestedQuestions?.length < 4 && (
                      <Button
                        type="plus"
                        transparent
                        buttonType="button"
                        onClick={() => {
                          formik.setFieldValue('suggestedQuestions', [
                            ...(formik.values.suggestedQuestions || []),
                            '',
                          ]);
                        }}
                        className={styles['button']}
                      />
                    )}
                  </div>
                  {formik.values.suggestedQuestions.map((variant, index) => (
                    <div className={styles['multi-input']} key={index}>
                      <Input
                        name={`suggestedQuestions.${index}.question`}
                        value={variant?.question}
                        onChange={formik.handleChange}
                        errors={
                          formik.errors?.suggestedQuestions?.[index]?.question
                        }
                        touched={
                          formik.touched?.suggestedQuestions?.[index]?.question
                        }
                        placeholder="Enter a question"
                        maxLength="30"
                      />
                      <div className={styles['variant-action']}>
                        <SvgWithBranding
                          type="delete_table"
                          className={styles.icon}
                          onClick={() => {
                            const updatedVariants =
                              formik.values.suggestedQuestions.filter(
                                (_, i) => i !== index
                              );
                            formik.setFieldValue(
                              'suggestedQuestions',
                              updatedVariants
                            );
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </>
              ) : null}
            </>
          ) : null}
        </>
      ) : (
        <></>
      )}

      {/* {formik?.values.hasSuggestions && <div className={styles.border}></div>}

      <div className={styles.suggest}>
        <p>Reassess Intent</p>
        <Toggle
          name='reassessIntent'
          value={formik.values.reassessIntent || false}
          onToggleChange={(e) => {
            formik.setFieldValue(
              `reassessIntent`,
              !formik.values.reassessIntent
            );
          }}
        />
      </div> */}
    </form>
  );
};

export default InitialForm;
